<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmc"><span class="bold">Acknowledgements</span></h2>
<p class="noindent">Heart-felt thanks to my family; to André for his strength, patience and for years of letting me be myself. To my wonderful, inspiring children, Manuela, Toby and Louis; as every day is a school day, this one’s for you. To Dot and Len who started it all – and are much missed – and Jez for his wisdom and for introducing me to Conté crayons.</p>
<p class="noindentt">A big thank you to Nel, for years of support and collaboration, and without whom this book wouldn’t have happened. To Colin Johnson for the cloud advice; Hannah Murphy for her equestrian knowledge; and to Ron Tiner for his book on figure drawing. For the use of their inspiring photographs, I would like to thank Nel Whatmore, Teresa Grant, Toby de Mendonça, Sarah Bradley and Dawn Westcott. Last but not least, to Edd the editor, who deserves a medal, and the great team at Search Press.</p>
<div class="img_containerp">
<img alt="Image" src="images/f005-01.jpg"/>
<p class="caphead"><span class="bold">Racing the Tide</span></p>
<p class="caption"><span class="bold"><em class="italic">This painting is all about the frenzied dash to save the sandcastle as the tide comes in. Both boys are bent right over, but even though they are moving, they are still balanced by the position of their feet in relation to their heads.</em></span></p>
</div>
<div class="img_container">
<img alt="Image" src="images/f004-01.jpg"/>
<p class="caphead"><span class="bold">Dartmoor Ponies</span></p>
<p class="caption"><span class="bold"><em class="italic">I love the vast and dramatic landscape of Dartmoor, and like to give a sense of scale to this landscape by including life. Here, that life is in the form of the ponies who live wild on the moor. These landscapes are a great opportunity to experiment with mark-making techniques.</em></span></p>
</div>
<div class="img_container">
<img alt="Image" src="images/f003-01.jpg"/>
<p class="caphead"><span class="bold">Having Fun</span></p>
<p class="caption"><span class="bold"><em class="italic">This Arabian yearling is full of life and excitement. Here I went for the less-is-more approach by using a background surface that is very close to her colour, so that it is part of the palette. I focused on her lovely face and flared nostrils, while just hinting at her body with some light and shadow. I am relying on the viewer’s brain to ‘fill in the gaps’ so that they get the sense of the yearling moving quickly, without all of the detail.</em></span></p>
</div>
<div class="img_container">
<img alt="Image" src="images/f006-01.jpg"/>
<p class="caphead"><span class="bold">Sitting on the Steps</span></p>
<p class="caption"><span class="bold"><em class="italic">This painting of Trafalgar Square in winter sunlight uses warm ochres to show the areas of light, and lilacs and blues for the shadows. There are greater tonal contrasts in the foreground to create a sense of depth.</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknow.vue?e2c1a80a